// extracted by mini-css-extract-plugin
export default {"PdfViewer":"K9Lsu","PasswordBlock":"NE7dS","error":"j_RWl","PasswordProtected":"pwbOD","PasswordMessage":"TlvVX","input":"yXz86","LockIcon":"v4uTU","pdfviewerSection":"vJ_2f"};